import { styled } from "styled-components";
import { useState, useEffect } from "react";
import { useAuth } from "../../../../auth/contexts/auth.provider";
import {
  ProfileTheme_1Icon,
  ProfileTheme_2Icon,
  ProfileTheme_3Icon,
  ProfileTheme_4Icon,
  ProfileTheme_5Icon,
} from "@dataone/icons";

interface ChatQuestionsProps {
  message: string;
}

const ChatQuestions = ({ message }: ChatQuestionsProps) => {
  const { user } = useAuth();

  interface ProfileIcons {
    [key: string]: JSX.Element;
  }

  const profileIcons: ProfileIcons = {
    "1": <ProfileTheme_1Icon />,
    "2": <ProfileTheme_2Icon />,
    "3": <ProfileTheme_3Icon />,
    "4": <ProfileTheme_4Icon />,
    "5": <ProfileTheme_5Icon />,
  };

  return (
    <StyledContainer>
      <StyledIcon>
        {profileIcons[(user?.avatar || 1) as keyof ProfileIcons]}
      </StyledIcon>
      <div className="qst-desc">{message}</div>
      {/* <div className="action">
        <img
          src={"images/smart-search/chat/pencil-icon.svg"}
          alt="pencil-icon"
        />
      </div> */}
    </StyledContainer>
  );
};

export default ChatQuestions;

const StyledContainer = styled.div`
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  padding: 10px 5px;
  margin: 10px 0px;
  align-items: center;
  cursor: pointer;
  .qst-desc {
    color: #040726;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.3px;
    margin-left: 20px;
  }
  .action {
    margin-left: auto;
    img {
      margin-right: 10px;
    }
    display: none;
  }
  &:hover {
    border-radius: 15px;
    border-right: 5px solid #4974f6;
    background: #fff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;

    .action {
      display: block;
    }
  }
`;

const StyledIcon = styled.div`
  font-size: 35px;
  display: flex;
`;
